import { DispatchDashboard as ServerDispatchDashboard } from 'server/models/DispatchDashboard';

export {
    DispatchDashboardData,
    DispatchDashboardOptions,
    DispatchDashboardCorePermissions,
    DispatchDashboardCorePermissionsData,
    DispatchDashboardCorePermissionsOptions
} from 'server/models/DispatchDashboard';

export class DispatchDashboard extends ServerDispatchDashboard {
    CanAddPilotJobOrders() {
        return !!this.CorePermissions() && this.CorePermissions()!.CanAddPilotJobOrders();
    }

    CanExportSchedule() {
        return !!this.CorePermissions() && this.CorePermissions()!.CanExportSchedule();
    }

    CanManageBills() {
        return !!this.CorePermissions() && this.CorePermissions()!.CanManageBills();
    }

    CanManageDispatchEvents() {
        return !!this.CorePermissions() && this.CorePermissions()!.CanManageDispatchEvents();
    }

    CanReserveBerths() {
        return !!this.CorePermissions() && this.CorePermissions()!.CanReserveBerths();
    }
}



// WEBPACK FOOTER //
// ./data/models/DispatchDashboard.ts